import { SxProps, Theme } from '@mui/material'

/**
 * Icon draw size inside right-sidebar bottom controls (unchanged when button grows).
 * The tab icons above are 40px boxes whose artwork covers ~23px; these 24-unit icons cover
 * 18-22 of their box, so 28px brings their drawn size in line with the tabs.
 */
export const SIDE_BAR_BOTTOM_ICON_SIZE = 28

/** 40×40 hit target; pair with `sideBarBottomIconStackSx` so icon spacing stays fixed. */
export const sideBarBottomIconButtonSx: SxProps<Theme> = {
    minWidth: 40,
    width: 40,
    maxWidth: 40,
    height: 40,
    padding: '6px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '& .MuiSvgIcon-root': {
        fontSize: SIDE_BAR_BOTTOM_ICON_SIZE
    },
    '& svg': {
        width: SIDE_BAR_BOTTOM_ICON_SIZE,
        height: SIDE_BAR_BOTTOM_ICON_SIZE,
        flexShrink: 0
    }
}

export const mergeSideBarBottomButtonSx = (
    extra?: SxProps<Theme>
): SxProps<Theme> => (extra ? [sideBarBottomIconButtonSx, extra] : sideBarBottomIconButtonSx)

/** Tighter than `gap={1}` so larger buttons do not push icons farther apart. */
export const sideBarBottomIconStackSx: SxProps<Theme> = {
    gap: '4px'
}
